import { render, staticRenderFns } from "./TablePaginatorExtended.vue?vue&type=template&id=01b9c90a"
import script from "./TablePaginatorExtended.vue?vue&type=script&lang=js"
export * from "./TablePaginatorExtended.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports